export const EQUAL_HASH_MODE = 'EQUAL';
export const GREATER_HASH_MODE = 'GREATER';